import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Form,
  Input,
  Button,
  Upload,
  notification,
  Select,
} from "antd";
import { UploadOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import http from "../../helpers/http";

const { TextArea } = Input;
const { Option } = Select;
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/";
const base_url = `${API_URL}admin/signature-spaces`;

function SignatureSpaceCreate() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("title", values.title || "");
      formData.append("description", values.description || "");
      formData.append("orderId", values.orderId || 0);
      formData.append("status", values.status || "active");
      formData.append("productLink", values.productLink || "");

      if (fileList.length > 0 && fileList[0].originFileObj) {
        formData.append("img", fileList[0].originFileObj);
      }

      await http.post(base_url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      notification.success({ message: "Signature Space created successfully" });
      navigate("/signature-spaces");
    } catch (error) {
      notification.error({
        message: "Error creating Signature Space",
        description: error?.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleUploadChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to="/signature-spaces">Signature Spaces</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Create</Breadcrumb.Item>
      </Breadcrumb>

      <Card
        title="Create Signature Space"
        extra={
          <Button
            type="primary"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate("/signature-spaces")}
          >
            Back
          </Button>
        }
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit} initialValues={{ status: 'active', orderId: 0 }}>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Title"
                name="title"
                rules={[{ required: true, message: "Please input the title!" }]}
              >
                <Input placeholder="Signature Space title" />
              </Form.Item>
            </Col>
            
            <Col xs={24} md={12}>
              <Form.Item
                label="Order ID"
                name="orderId"
                rules={[{ required: true, message: "Please input the order ID!" }]}
              >
                <Input type="number" placeholder="0" />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item
                label="Description"
                name="description"
              >
                <TextArea rows={4} placeholder="Signature Space description" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item label="Image Upload">
                <Upload
                  listType="picture"
                  maxCount={1}
                  fileList={fileList}
                  onChange={handleUploadChange}
                  beforeUpload={() => false}
                  customRequest={dummyRequest}
                  accept="image/*"
                >
                  <Button icon={<UploadOutlined />}>Select Image</Button>
                </Upload>
              </Form.Item>
            </Col>

            <Col xs={24} lg={12}>
                <Form.Item label="Product Link" name="productLink">
                    <Input placeholder="/product/example-slug" />
                </Form.Item>
            </Col>

            <Col xs={24} lg={12}>
                <Form.Item label="Status" name="status">
                    <Select>
                        <Option value="active">Active</Option>
                        <Option value="inactive">Inactive</Option>
                    </Select>
                </Form.Item>
            </Col>

            <Col xs={24}>
              <Button type="primary" htmlType="submit" loading={loading}>
                Create Signature Space
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}

export default SignatureSpaceCreate;
